import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";

import { Pagination } from "@mui/material";
import useStateRef from 'react-usestateref';
import swal from 'sweetalert';
import toast, { Toaster } from 'react-hot-toast';
import {useLocation } from 'react-router-dom';

import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";
import config from "../../../config/config";



const MasterProduct = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [product, setProduct] = useState([]);
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();

  const [pid, setPid, pidRef] = useStateRef();
  const [prodname, setProdname, prodnameRef] = useStateRef('');
  const [tag, setTag, tagRef] = useStateRef('');
  const [subpd, setSubpd, subpdRef] = useStateRef('');
  const [sstatement, setSstatement, sstatementRef] = useStateRef('');
  const [deptc, setDeptc, deptcRef] = useStateRef('');

  const [Search, setSearch, SearchRef] = useStateRef('');

  const [NewElg, setNewElg,NewElgRef] = useStateRef(false);
  const [EditElg, setEditElg,EditElgRef] = useStateRef(false);
  const [DeleteElg, setDeleteElg,DeleteElgRef] = useStateRef(false);
  const [ViewElg, setViewElg,ViewElgRef] = useStateRef(false);


  const [btndisabled, setDisabled] = useState('disabled');
  const [resultss, setResultss, resultssRef] = useStateRef();

  const [errors, setErrors] = useState({});


  const notify1 = () => toast.success('Successfully Deleted.');
  const notify2 = () => toast.error("Not able to Delete");
  const location = useLocation();
  debugger;

  useEffect(() => {
    debugger;


   

    if (location.state!=undefined || location.state!=null){

      setNewElg(location.state.NewElg);
      setEditElg(location.state.EditElg);
      setDeleteElg(location.state.DeleteElg);
      setViewElg(location.state.ViewElg);

      sessionStorage.setItem("Product_NewElg", NewElgRef.current);
      sessionStorage.setItem("Product_EditElg", EditElgRef.current);
      sessionStorage.setItem("Product_DeleteElg", DeleteElgRef.current);
      sessionStorage.setItem("Product_ViewElg", ViewElgRef.current);
}
    else
    {
      setNewElg(sessionStorage.getItem("Product_NewElg")==='true' ? true: false);
      setEditElg(sessionStorage.getItem("Product_EditElg")==='true' ? true: false);
      setDeleteElg(sessionStorage.getItem("Product_DeleteElg")==='true' ? true: false);
      setViewElg(sessionStorage.getItem("Product_ViewElg")==='true' ? true: false);
    }

      if (EditElgRef.current==true){
        setDisabled('');
      }
      else
      {
        setDisabled('disabled');
      }
    
   
    
    getProductData(1);
  }, []);

  const ProductPg = (event, value) => {
    getProductData(value);
  };

  async function getProductData(page) {
    try {
      let postData = {
        PageNumber: String(page),
        RowspPage: config.pageCount,
        Search: SearchRef.current
      }
      let results = await apiService.getProduct(apiPath.master.get.getproduct, postData);
      if (results != "-1") {
        console.log(results, "ress");

        setProduct(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function insertUpdateProduct() {
    try {
      let postData = {
        "prodname": prodnameRef.current,
        "taged": tagRef.current,
        "subproduct": subpdRef.current,
        "deptcode": deptcRef.current,
        "id": Number(pidRef.current),
        "StatementType": String(sstatementRef.current)
      }
      let results = await apiService.insertUpdateProduct(apiPath.master.insertUpdate.insertUpdateProduct, postData);
      if (results != "-1") {

        setResultss(results)
       
        console.log(results, "result insert");
      }
    } catch (e) {
      console.log(e);
    }

  }

  const SubmitCall = () => {
    try {
      const isFormValid = validateForm();
      if (isFormValid) {
        insertUpdateProduct();
        swal({
          title: "Success",
          text: "Successfully Added",
          icon: "success",
          button: "Ok"
        }).then(function () {
          setShow1(false);
          getProductData(currentpgRef.current);
        });
      }
    } catch (e) {
      console.log(e);

    }
  }

  const handleClose1 = () => setShow1(false);
  const handleShow1 = (type, id, prodname, tag, sub, deptid, statement, show) => {
    setPid(id);
    setProdname(prodname);
    setTag(tag);
    setSubpd(sub);
    setSstatement(statement);
    setDeptc(deptid)

    if (statement == 'Delete') {
      insertUpdateProduct();
      if (resultssRef.current == 'Success') {
        getProductData(currentpgRef.current);
        notify1();
        
      }
      else {
        notify2();
      }
    }


    if (type == 1) {//add
      setSho('Add New');
      setShow('Save');
    } else {//edit
      setSho('Edit');
      setShow('Update');
    }
    setShow1(show);
  }

  const validateForm = () => {
    const newErrors = {};
    if (!prodname.trim()) {
      newErrors.prodname = 'Account Name is required';
    } if (!deptc.trim()) {
      newErrors.deptc = 'Account Name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">To Add, Modify Product details.</h4>
                <Toaster
                  position="bottom-right"
                  reverseOrder={false}
                />
              </div>
              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                   <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" value={Search}  onChange={(e)=>{setSearch(e.target.value)}} className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={(e)=>{
                      
                       setcurrentpg(1)
                       getProductData(currentpgRef.current)}}>
                 <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col d-flex justify-content-end"> 
              {NewElg && 
                <Button className="text-center btn-primary btn-icon mt-lg-0 mt-md-0 mt-3 "
                  onClick={() => { handleShow1(1, " ", "", false, false, " ", "Insert", true) }}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add</span>
                </Button>
              }
                <Modal show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Product</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-3" >

                      <div className='mb-2'>
                        <Form.Label>Prod.Head Code</Form.Label>
                        <Form.Control type="text" id='ProCode' value={pid} disabled={true} />
                      </div>

                      <div className='mb-2'>
                        <Form.Label>Prod.Head Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" id='ProName' value={prodname} onChange={(e) => setProdname(e.target.value)} placeholder="" isInvalid={!!errors.prodname}/>
                      </div>

                      <div className='mb-2'>
                        <Form.Label>Department Name <span className="text-danger">*</span></Form.Label>
                        <select className="form-select" id="deptname" value={deptc} onChange={(e) => setDeptc(e.target.value)} isInvalid={!!errors.deptc} disabled={pidRef.current != 0 ? true : false}>
                          <option >Select Option</option>
                          <option value={1}>Gold</option>
                          <option value={2}>Silver</option>
                        </select>
                      </div>

                      <div style={{ display: 'flex', paddingTop: '1%' }}>

                        <div style={{ paddingLeft: '3px' }}>
                          <Form.Check.Input type="checkbox" className="me-2" id='tag' onChange={(e) => setTag(e.target.checked)} checked={tag} />
                          <Form.Check.Label htmlFor="flexCheckDefault">
                            Tag
                          </Form.Check.Label>
                        </div>

                        <div style={{ paddingLeft: '10px' }}>
                          <Form.Check.Input type="checkbox" className="me-2" id='subpd' onChange={(e) => setSubpd(e.target.checked)} checked={subpd} />
                          <Form.Check.Label htmlFor="flexCheckDefault">
                            Sub Product
                          </Form.Check.Label>
                        </div>

                      </div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                      <Button variant="primary" disabled={btndisabled} onClick={() => { SubmitCall() }}>{show} </Button>		{' '}
                      <Button variant="danger" onClick={handleClose1}>  Cancel </Button>
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"
                >
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Product Name</th>
                      <th>Department</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {product.map((item) => (
                      <tr>
                        <td>{item.ProdCode}</td>
                        <td>{item.ProdName}</td>
                        <td>{item.DeptName}</td>
                        {(EditElg || ViewElg) && 
                        <td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit User" to="#"
                            onClick={() => { handleShow1(2, item.ProdCode, item.ProdName, item.Taged, item.SubProduct, item.DeptCode, "Update", true) }} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>
                        }
                        
                         
                        <td>
                        {DeleteElg && 
                          <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete User" to="#"
                            onClick={() => { handleShow1(0, item.ProdCode, "", false, false, " ", "Delete", false) }}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
 }
                        </td>
                     

                      </tr>
                    ))}
                  </tbody>

                </Table>
                <div style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 0 3px 0px', width: '100%', justifyContent: 'space-between' }}>
                  <div>
                    Showing {(currentpgRef.current - 1) * 10 + 1} to {currentpgRef.current * 10} of {totalCountRef.current} entries
                  </div>
                  <div>
                    <Pagination count={Math.ceil(totalCountRef.current / config.pageCount)} page={nopageRef.current} color="primary" onChange={ProductPg} />
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default MasterProduct;
